/**
 * On-device persistence, over IndexedDB via idb-keyval.
 *
 * IndexedDB rather than localStorage because localStorage is synchronous and blocks the
 * main thread — and on this project the main thread is the frame budget.
 *
 * Nothing here ever rejects. Storage can be unavailable (Safari private browsing), full,
 * or corrupt, and none of those should stop a player from playing. Reads fall back to
 * defaults, writes fail silently.
 */

import { get, set } from 'idb-keyval';
import { DEFAULT_SETTINGS, parseSettings, type Settings } from '../game/settings';

/**
 * Versioned so that a future settings format cannot be misread as this one. When the
 * shape changes incompatibly, bump the version and leave the old key to be ignored.
 */
export const SETTINGS_KEY = 'lab17:settings:v1';

export async function loadSettings(): Promise<Settings> {
  try {
    return parseSettings(await get(SETTINGS_KEY));
  } catch {
    return { ...DEFAULT_SETTINGS };
  }
}

export async function saveSettings(settings: Settings): Promise<void> {
  try {
    await set(SETTINGS_KEY, settings);
  } catch {
    // Losing a preference is not worth interrupting play over.
  }
}
